// styles
import { Tooltip } from "antd";
import "./InputBox.scss";
// services
import truckTracker from "assets/images/map.svg";
import TickCircel from "assets/images/tickCircle.svg";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { BsSearch, BsTelephone } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
import { RiLightbulbFlashFill } from "react-icons/ri";

const InputBox = (props) => {
  let {
    id,
    placeholder = "",
    register = {},
    value = "",
    type = "",
    onChange,
    name = "",
    className = "",
    grayedBox = false,
    profile = false,
    shadow = false,
    disabled = false,
    maxLength,
    SearchIcon = false,
    confirm = false,
    isOtp = false,
    Message = false,
    Password = false,
    call = false,
    setPassword,
    showPassword = false,
    notesBox = false,
    searchBox = false,
    proposal = false,
    sendOtp,
    supplierOTP,
    memberOtp,
    agentOtp,
    customerOtp,
    supplierOtp,
    onSubmitExist,
    onKeyDown,
    quantity,
    ISpanValidGreen,
    ISpanValidRed,
    upperCaseLabel = false,
    isTracker = false,
    hideTickMark = false,
    inputError = false,
    disabledOtpBtn = false,
    isDynamic = false,
    autoFocus = false,
    isBulbIcon=false
  } = props;

  const handleKeyDown = (e) => {
    if (type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault(); // prevent increment/decrement
    }

    if (onKeyDown) {
      onKeyDown(e); // allow custom onKeyDown handler if provided
    }
  };

  return (
    <>
      {notesBox ? (
        <div>
          <textarea
            {...register}
            disabled={disabled}
            name={name}
            placeholder={placeholder}
            className={
              disabled ? "inputBoxGrayed" : notesBox ? "NotesinputBoxStyle" : ""
            }
            defaultValue={value}
            maxLength={maxLength}
            onWheel={(event) => event.currentTarget.blur()}
            onChange={(e) => {
              const body = {
                target: {
                  name: e.target.name,
                  value: e.target.value,
                },
              };
              if (onChange) onChange(body);
            }}
            autoComplete={"off"}
          />
        </div>
      ) : proposal ? (
        <div className="input_head">
          <input
            disabled={disabled}
            name={name}
            placeholder={placeholder}
            className={`
            ${
              disabled
                ? "inputBoxGrayed"
                : grayedBox
                ? "inputBoxGrayed"
                : shadow
                ? "inputBoxIconStyle"
                : notesBox
                ? "NotesinputBoxStyle"
                : searchBox
                ? "searchBoxStyle"
                : "inputBoxStyle"
            } ${upperCaseLabel ? "uppercaseText" : ""}
              ${inputError ? "inputfiledError" : ""}
              `}
            {...register}
            defaultValue={value}
            type={type}
            maxLength={maxLength}
            onKeyDown={onKeyDown}
            onWheel={(event) => event.currentTarget.blur()}
            // onChange={(e) => {
            //   const body = {
            //     target: {
            //       name: e.target.name,
            //       value: e.target.value,
            //     },
            //   };
            //   if (onChange) onChange(body);
            //   register?.onChange?.(body);
            // }}
            // onChange={(e) => {
            //
            //   const body = {
            //     target: {
            //       name: e.target.name,
            //       value: e.target.value,
            //     },
            //   };
            //   if (onChange) onChange(body);
            // }}
            onChange={onChange}
            autoComplete={"off"}
          />
          <div>
            {SearchIcon ? (
              <i className="search_icon">
                <BsSearch color="grey" />
              </i>
            ) : confirm ? (
              <div className="search_icon">
                <span>Confirm</span>
              </div>
            ) : isOtp ? (
              <div className="search_icon">
                {customerOtp || supplierOtp || memberOtp || agentOtp ? (
                  <img src={TickCircel} alt="tick" />
                ) : (
                  <span
                    onClick={() => (disabledOtpBtn ? null : onSubmitExist())}
                  >
                    Send OTP
                  </span>
                )}
              </div>
            ) : Message ? (
              <i className="message_icon">
                <FiMail />
              </i>
            ) : call ? (
              <i className="message_icon">
                <BsTelephone size={20} />
              </i>
            ) : Password ? (
              <i className="password_icon">
                {" "}
                <span onClick={() => setPassword(!showPassword)}>
                  {!showPassword ? (
                    <AiOutlineEye style={{ fontSize: "20px" }} />
                  ) : (
                    <AiOutlineEyeInvisible style={{ fontSize: "20px" }} />
                  )}
                </span>
              </i>
            ) : quantity ? (
              <div className="metric_wrapper">
                <label className="metric_tons">Metric Tons</label>
              </div>
            ) : isTracker ? (
              <div className="message_icon">
                <img src={truckTracker} alt="track" />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : isDynamic ? (
        <div className="input_head">
          <input
            disabled={disabled}
            name={name}
            id={id}
            placeholder={placeholder}
            className={`${className}
            ${
              disabled
                ? "inputBoxGrayed"
                : grayedBox
                ? "inputBoxGrayed"
                : shadow
                ? "inputBoxIconStyle"
                : notesBox
                ? "NotesinputBoxStyle"
                : searchBox
                ? "searchBoxStyle"
                : ISpanValidRed
                ? " inputBoxStyle invalidRedBorder shakeInput"
                : profile
                ? "inputBoxStyleProfile"
                : "inputBoxStyle"
            }  ${upperCaseLabel ? "uppercaseText" : ""}
            ${inputError ? "inputfiledError" : ""}
            
            `}
            {...register}
            value={value}
            type={type}
            maxLength={maxLength}
            onKeyDown={onKeyDown}
            onWheel={(event) => event.currentTarget.blur()}
            onChange={(e) => {
              const body = {
                target: {
                  name: e.target.name,
                  value: e.target.value,
                },
              };
              if (onChange) onChange(body);
              register?.onChange?.(body);
            }}
            autoComplete={"off"}
          />
        </div>
      ) : (
        <div className="input_head">
          <input
            disabled={disabled}
            name={name}
            id={id}
            placeholder={placeholder}
            className={`${className}
            
            ${
              disabled
                ? "inputBoxGrayed"
                : grayedBox
                ? "inputBoxGrayed"
                : shadow
                ? "inputBoxIconStyle"
                : notesBox
                ? "NotesinputBoxStyle"
                : searchBox
                ? "searchBoxStyle"
                : ISpanValidRed
                ? " inputBoxStyle invalidRedBorder shakeInput"
                : profile
                ? "inputBoxStyleProfile"
                : "inputBoxStyle"
            }  ${upperCaseLabel ? "uppercaseText" : ""}
            ${inputError ? "inputfiledError" : ""}
            
            `}
            {...register}
            defaultValue={value}
            autoFocus={autoFocus}
            type={type}
            maxLength={maxLength}
            onKeyDown={handleKeyDown}
            onWheel={(event) => event.currentTarget.blur()}
            onChange={(e) => {
              const body = {
                target: {
                  name: e.target.name,
                  value: e.target.value,
                },
              };
              if (onChange) onChange(body);
              register?.onChange?.(body);
            }}
            autoComplete={"off"}
          />
          <div>
            {ISpanValidGreen ? (
              <div className="search_icon">
                <img src={TickCircel} alt="tick" />
              </div>
            ) : ISpanValidRed ? (
              <></>
            ) : // <div className="search_icon">
            //   <img src={CancelCircle} alt="tick" />
            // </div>
            SearchIcon ? (
              <i className="search_icon">
                <BsSearch color="grey" />
              </i>
            ) : confirm ? (
              <div className="search_icon">
                <span>Confirm</span>
              </div>
            ) : isOtp ? (
              <div className="search_icon">
                {customerOtp ||
                supplierOtp ||
                memberOtp ||
                supplierOTP ||
                agentOtp ? (
                  <img src={hideTickMark ? null : TickCircel} alt="" />
                ) : (
                  <span
                    onClick={() => (disabledOtpBtn ? null : onSubmitExist())}
                  >
                    {"Send OTP"}
                  </span>
                )}
              </div>
            ) : Message ? (
              <i className="message_icon">
                <FiMail />
              </i>
            ) : call ? (
              <i className="message_icon">
                <BsTelephone size={20} />
              </i>
            ) : Password ? (
              <i className="password_icon">
                {" "}
                <span onClick={() => setPassword(!showPassword)}>
                  {!showPassword ? (
                    <AiOutlineEye style={{ fontSize: "20px" }} />
                  ) : (
                    <AiOutlineEyeInvisible style={{ fontSize: "20px" }} />
                  )}
                </span>
              </i>
            ) : quantity ? (
              <div className="metric_wrapper">
                <label className="metric_tons">Metric Tons</label>
              </div>
            ) : isTracker ? (
              <div className="message_icon">
                <img src={truckTracker} alt="track" />
              </div>
            ) : isBulbIcon ? (
              <Tooltip
                className="search_icon"
                title="Values must follow the selected ratio format (e.g., 1:0, 1:0.5)."
              >
                <span>
                  <RiLightbulbFlashFill size={20} color="#0066b3" />
                </span>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InputBox;
